// angular imports
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

// devextreme imports
import { DxPopupComponent } from 'devextreme-angular';

// cc-common imports
import { IconConstants } from 'cc-common';

@Component({
    selector: 'app-workflow-payment-work-order-selector',
    templateUrl: './workflow-payment-work-order-selector.component.html',
    styleUrls: ['./workflow-payment-work-order-selector.component.scss']
})
export class WorkflowPaymentWorkOrderSelectorComponent implements OnInit {
    @ViewChild('workOrderSelector', { static: false }) workOrderSelector: DxPopupComponent;

    @Input() communityId: number;
    @Input() vendorId: number;
    @Input() workOrderIds: Array<number> = [];

    @Output() onClose = new EventEmitter<void>();
    @Output() onWorkOrderSelection = new EventEmitter<number[]>();

    visible = false;

    iconCheck = IconConstants.CHECK;
    iconFolder = IconConstants.FOLDER_PLUS;
    iconClose = IconConstants.CLOSE;

    ngOnInit() {
        this.show();
    }

    show(): void {
        this.visible = true;
    }

    onWorkOrderShown(): void {
        this.workOrderSelector.instance.repaint();
    }

    onWorkOrderClose(): void {
        this.closeWorkOrderSelector();
    }

    onWorkOrderIdSelection(workOrderIds: Array<number>): void {
        this.onWorkOrderSelection.emit(workOrderIds);
    }

    onWorkOrderSelect(): void {
        this.onWorkOrderSelection.emit(this.workOrderIds);
        this.closeWorkOrderSelector();
    }

    private closeWorkOrderSelector(): void {
        this.visible = false;
        this.onClose.emit();
    }
}
